import React from 'react';
import AgreementComponent from './AgreementComponent';

const DSAComponent = ({ form, currentStatus, showTitle = true, organisation = null, onSaveChanges = null, loading = false }) => {
  // Default DSA JSON structure
  const defaultDSAStructure = {
    dataSharing: {
      patientDataAccess: false,
      clinicalDataSharing: false,
      researchDataAccess: false,
      anonymizedDataSharing: false,
      dataRetentionCompliance: false,
      gdprCompliance: false,
      nhsDataStandards: false,
      crossOrganisationSharing: false
    },
    technical: {
      secureDataTransmission: false,
      encryptionStandards: false,
      accessControls: false,
      auditLogging: false,
      dataBackup: false,
      disasterRecovery: false
    },
    legal: {
      dataProtectionAct: false,
      nhsConstitution: false,
      careActCompliance: false,
      mentalHealthAct: false,
      confidentialityAgreement: false
    }
  };

  return (
    <AgreementComponent
      form={form}
      currentStatus={currentStatus}
      agreementType="dsa"
      title="Data Sharing Agreement (DSA)"
      description="NHS data sharing standards and patient data protection requirements"
      defaultStructure={defaultDSAStructure}
      showTitle={showTitle}
      organisation={organisation}
      onSaveChanges={onSaveChanges}
      loading={loading}
    />
  );
};

export default DSAComponent;
